import { apiGet, apiPost, apiDelete } from 'helpers/ApiHelper';
import { toDate, objectToQuery } from 'helpers/Formatter';
import { hostIsCapreit } from 'helpers/CurrentWindowLocation';

import Auth from 'j-toker';

import * as notifications from './notificationActions';
import * as maintenanceActions from './maintenanceActions';
import { showFailure } from './notificationActions';

export function getMaintenanceWorkerTicket(ticket_id) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/maintenance/maintenance_ticket/${ticket_id}`)
        .done(response => {
          return dispatch(saveTicket(response.maintenance_ticket));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function getTicketsStats() {
  const route = '/landlords/maintenance_tickets_stats';
  return dispatch => {
    return dispatch({
      type: 'MAINTENANCE::FETCH_TICKETS_STATS',
      payload: apiGet(Auth.getApiUrl() + route).done(response => {
        dispatch({
          type: 'MAINTENANCE::SAVE_TICKETS_STATS',
          payload: response.maintenance_tickets_counts,
        });
      }),
    });
  };
}

// This only loads the first 20 items
// This is to avoid server explosion due to big volume of tickets
// Needs to be addressed later for ticket scheduler and maintenance insight page
export function getAllMaintenanceTickets(options) {
  // Options: show_closed: true will return list of all maintenance tickets.
  let route = '/landlords/maintenance_tickets';
  if (options) {
    route += objectToQuery(options);
  }

  return dispatch => {
    return dispatch({
      type: 'MAINTENANCE::FETCH_TICKETS',
      payload: apiGet(Auth.getApiUrl() + route)
        .done(response => {
          dispatch(
            saveAllTickets(
              response.maintenance_tickets.sort((a, b) => {
                return new Date(b.last_updated) - new Date(a.last_updated);
              }),
              Date.now()
            )
          );
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function getFilteredMaintenanceTickets(subset = 'all', offset = 0, options = {}) {
  return dispatch => {
    return dispatch({
      type: 'MAINTENANCE::FETCH_MORE_TICKETS',
      payload: apiPost(
        `${Auth.getApiUrl()}/landlords/filtered_maintenance_tickets?subset=${subset}&offset=${offset}`,
        options
      )
        .done(response => {
          return dispatch(
            saveMoreTickets(
              response.maintenance_tickets,
              offset || 0,
              response.search_total_results_count
            )
          );
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function saveMoreTickets(data, offset, searchTotalResultsCount = null) {
  return {
    type: 'MAINTENANCE::SAVE_MORE_TICKETS',
    maintenance_tickets: data,
    offset,
    searchTotalResultsCount,
  };
}

export function saveAllTickets(data, timestamp) {
  return {
    type: 'MAINTENANCE::SAVE_ALL_TICKETS',
    maintenance_tickets: data,
    timestamp,
  };
}

export function getTicket(ticket_id) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/maintenance_tickets/${ticket_id}`)
        .done(response => {
          dispatch(saveTicket(response.maintenance_ticket));
          dispatch(
            maintenanceActions.getListOfMaintenanceStaff(response.maintenance_ticket.property_id)
          );
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function saveTicket(data) {
  if (data.scheduled_at) {
    data.scheduled_at = toDate(data.scheduled_at);
  }
  if (data.scheduled_starts_at_date) {
    data.scheduled_starts_at_date = toDate(data.scheduled_starts_at_date);
  }
  if (data.transaction_date) {
    data.transaction_date = toDate(data.transaction_date);
  }
  if (data.schedule_start_date) {
    data.schedule_start_date = toDate(data.schedule_start_date);
  }
  if (!data.scheduled_duration) {
    data.scheduled_duration = hostIsCapreit() ? 4 : 0.5;
  }
  if (data.schedule_end_date) {
    data.schedule_end_date = toDate(data.schedule_end_date);
  }

  if (data.events) {
    data.events = data.events.map(event => {
      return {
        ...event,
        time: toDate(event.time),
      };
    });
  }
  return {
    type: 'MAINTENANCE::GET_TICKET',
    details: data,
  };
}

export function openDialog() {
  return {
    type: 'MAINTENANCE::OPEN_DIALOG',
  };
}

export function closeDialog() {
  return {
    type: 'MAINTENANCE::CLOSE_DIALOG',
  };
}

export function deleteTicket(ticket_id, cancellationReason = 'cancelled') {
  return dispatch => {
    return dispatch({
      payload: apiDelete(
        Auth.getApiUrl() +
          `/landlords/maintenance_tickets/${ticket_id}?cancellation_reason=${cancellationReason}`
      )
        .done(response => {
          return dispatch(notifications.showSuccess('ticketSuccessfullyCancelled'));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          throw error;
        }),
    });
  };
}

export function getNotes(ticketId, options) {
  let route = `/maintenance_tickets/${ticketId}/notes`;
  if (options) {
    route += objectToQuery(options);
  }
  return dispatch => {
    return dispatch({
      type: 'MAINTENANCE::FETCH_NOTES',
      payload: apiGet(Auth.getApiUrl() + route)
        .done(response => {
          dispatch(showNotes(response.maintenance_ticket_notes));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function showNotes(maintenanceTicketNotes) {
  return {
    type: 'MAINTENANCE::SHOW_NOTES',
    maintenanceTicketNotes,
  };
}

export function clearNotes() {
  return {
    type: 'MAINTENANCE::CLEAR_NOTES',
  };
}

export function submitNote(formData, ticketId) {
  let dataClone = JSON.parse(JSON.stringify(formData));
  return dispatch => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + `/maintenance_tickets/${ticketId}/notes`, dataClone)
        .done(response => {})
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function remindVendor(ticketID) {
  return dispatch => {
    return dispatch({
      type: 'MAINTENANCE::REMIND_VENDOR',
      payload: apiPost(Auth.getApiUrl() + `/landlords/maintenance_tickets/${ticketID}/reminder`)
        .done(response => {
          return dispatch(notifications.showSuccess('successfullySentReminderToVendor'));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
          throw new Error();
        }),
    });
  };
}

export function downloadPdf(maintenanceTicketId) {
  // https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari
  let windowReference = window.open();

  return dispatch => {
    return dispatch({
      payload: apiPost(
        Auth.getApiUrl() + `/landlords/maintenance_tickets/${maintenanceTicketId}/pdf`
      )
        .done(response => {
          windowReference.location.assign(response.pdf_url);
        })
        .catch(error => {
          dispatch(showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}
